import { mergeConfig, RestResource} from '../rest'
import { athubAxios } from '../../util'

import { KNOWLEDGE_SERVER } from '../server'

const abstract = new RestResource({server: KNOWLEDGE_SERVER, resource: 'abstract'});
abstract.countByCategory = function(search, config) {
  return athubAxios.post([abstract.server, abstract.resource, 'category', 'count'].join('/'), search, mergeConfig(config));
};
abstract.getKeywords = function(id, config) {
  return athubAxios.get([abstract.server, abstract.resource, id, 'keyword'].join('/'), mergeConfig(config));
};
abstract.addKeywords = function(id, body, config) {
  return athubAxios.post([abstract.server, abstract.resource, id, 'keyword'].join('/'), body, mergeConfig(config));
};
abstract.matched = function(id, body, config) {
  return athubAxios.post([abstract.server, abstract.resource, id, 'matched'].join('/'), body, mergeConfig(config));
};
export default abstract;